<div class="view-container">
  <mat-card class="missing-sage-customers">
    <div class="missing-sage-customers__header">
      <div class="mbp-page-header">
        <div class="mbp-page-header__icon">
          <mat-icon>warning</mat-icon>
        </div>
        <h1 class="mbp-page-header__title">Companies missing a Sage customer code</h1>
      </div>
      <button type="button" mat-stroked-button (click)="load()" [disabled]="loading">
        <mat-icon>refresh</mat-icon>
        Refresh
      </button>
    </div>

    <p class="missing-sage-customers__intro">{{ missingWarning }}</p>
    <p class="missing-sage-customers__intro">{{ helper }}</p>
    <p class="missing-sage-customers__intro">
      Several companies can share one code, for example VET004. That is expected.
    </p>
    @if (incomplete) {
      <p class="missing-sage-customers__pending">Some companies could not be checked. Refresh to try again.</p>
    }

    <mat-form-field appearance="outline" class="missing-sage-customers__search" subscriptSizing="dynamic">
      <input matInput placeholder="Search by company id or name" [formControl]="searchInput" />
      <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>

    @if (loading) {
      <p class="missing-sage-customers__status">
        Checking companies… {{ companiesDone }} of {{ companyTotal || '…' }}
      </p>
    } @else {
      <p class="missing-sage-customers__status">{{ visibleRows.length }} companies</p>
    }

    <div class="mbp-table-wrap">
      <table mat-table [dataSource]="pagedRows" class="mbp-data-table missing-sage-customers__table">
        <ng-container matColumnDef="company_id">
          <th mat-header-cell *matHeaderCellDef>Company id</th>
          <td mat-cell *matCellDef="let row">{{ row.companyId }}</td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let row">
            <a [routerLink]="['/portal/companies/view', row.companyId]">{{ row.name }}</a>
          </td>
        </ng-container>

        <ng-container matColumnDef="sage_customer_code">
          <th mat-header-cell *matHeaderCellDef>Sage customer code</th>
          <td mat-cell *matCellDef="let row" class="sage-customer-code-col">
            @if (perm.canAddOrEditIndividualOrCompany()) {
              <div class="missing-sage-customers__code">
                <input
                  class="missing-sage-customers__input"
                  type="text"
                  autocomplete="off"
                  placeholder="e.g. VET004"
                  [value]="codeFor(row)"
                  (input)="onCodeInput(row, $any($event.target).value)"
                />
                <button
                  type="button"
                  mat-stroked-button
                  [disabled]="savingCompanyId !== null || loading"
                  (click)="save(row)"
                >
                  {{ savingCompanyId === row.companyId ? 'Saving…' : 'Save' }}
                </button>
              </div>
            }
            <span class="sage-customer-code-missing">{{ missingWarning }}</span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    @if (!loading && visibleRows.length > 0) {
      <mat-paginator
        class="missing-sage-customers__paginator"
        [length]="visibleRows.length"
        [pageIndex]="pageIndex"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        showFirstLastButtons
        (page)="onPageChange($event)"
        aria-label="Select page of companies"
      ></mat-paginator>
    }

    @if (!loading && rows.length === 0 && !incomplete) {
      <p class="missing-sage-customers__empty">No companies are missing a Sage customer code.</p>
    }
    @if (!loading && rows.length > 0 && visibleRows.length === 0) {
      <p class="missing-sage-customers__empty">No companies match this search.</p>
    }
  </mat-card>
</div>
